import { VuexModule, Module, Mutation, Action } from "vuex-module-decorators";

@Module({ name: "NavSidebarStore", namespaced: true })
class NavSidebarStore extends VuexModule {
  private sidebarShow: string | boolean = "responsive";
  private sidebarMinimize = false;

  @Mutation
  private toggleSidebarDesktopMutation() {
    const sidebarOpened = [true, "responsive"].includes(this.sidebarShow);
    this.sidebarShow = sidebarOpened ? false : "responsive";
  }

  @Mutation
  private toggleSidebarMobileMutation() {
    const sidebarClosed = [false, "responsive"].includes(this.sidebarShow);
    this.sidebarShow = sidebarClosed ? true : "responsive";
  }

  @Mutation
  private setSidebarShowMutation(sidebarShow: string | boolean) {
    this.sidebarShow = sidebarShow;
  }

  @Mutation
  private setSidebarMinimizeMutation(sidebarMinimize: boolean) {
    this.sidebarMinimize = sidebarMinimize;
  }

  @Action({ rawError: true })
  public toggleSidebarDesktop() {
    this.context.commit("toggleSidebarDesktopMutation");
  }

  @Action({ rawError: true })
  public toggleSidebarMobile() {
    this.context.commit("toggleSidebarMobileMutation");
  }

  @Action({ rawError: true })
  public setSidebarShow(sidebarShow: string | boolean) {
    this.context.commit("setSidebarShowMutation", sidebarShow);
  }

  @Action({ rawError: true })
  public setSidebarMinimize(sidebarMinimize: boolean) {
    this.context.commit("setSidebarMinimizeMutation", sidebarMinimize);
  }

  public get getSidebarShow() {
    return this.sidebarShow;
  }

  public get getSidebarMinimize() {
    return this.sidebarMinimize;
  }
}

export default NavSidebarStore;
